import {
  FETCH_POLICIES_REQUEST, FETCH_POLICIES_SUCCESS, FETCH_POLICIES_FAIL,
  FETCH_EMP_TYPES_REQUEST, FETCH_EMP_TYPES_SUCCESS, FETCH_EMP_TYPES_FAIL,
} from "../../constants/Leave/LeaveConfigConstants";

const initialState = {
  loading: false, data: [], error: null,                          // policies
  typesLoading: false, employeeTypes: [], typesError: null,       // employee types
};

const LeaveConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_POLICIES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_POLICIES_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_POLICIES_FAIL:
      return { ...state, loading: false, error: action.payload };

    case FETCH_EMP_TYPES_REQUEST:
      return { ...state, typesLoading: true, typesError: null };
    case FETCH_EMP_TYPES_SUCCESS:
      return { ...state, typesLoading: false, employeeTypes: action.payload };
    case FETCH_EMP_TYPES_FAIL:
      return { ...state, typesLoading: false, typesError: action.payload };
    default:
      return state;
  }
};

export default LeaveConfigReducer;